export const getObservations = (demand) => {
  const observations = []

  demand.visits.forEach((visit) => (visit.observation ? observations.push(visit.observation) : null))

  demand.services.forEach((service) => (service.observation ? observations.push(service.observation) : null))

  return observations
}
